import { toast } from 'sonner';

/**
 * Champs date / heure natifs : un `<input type="date|time|datetime-local">`
 * à moitié rempli (une heure sans date, un jour sans année) a une valeur
 * VIDE pour React — rien n'est enregistré, et l'écran affiche pourtant des
 * chiffres qui ont l'air d'une saisie. Le navigateur, lui, distingue « vide »
 * de « incomplet » : `validity.badInput`. Trouvé par Bryan le 2026-09-09 sur
 * la révélation d'un WOD mystère ; la même chose valait pour les 24 champs
 * date / heure de l'app.
 */
export const DATE_INPUT_SELECTOR = 'input[type="date"], input[type="datetime-local"], input[type="time"]';

export type DateInputKind = 'date' | 'time' | 'datetime-local';

export const INCOMPLETE_MESSAGE_KEY: Record<DateInputKind, string> = {
  date: 'common.dateIncomplete',
  time: 'common.timeIncomplete',
  'datetime-local': 'common.dateTimeIncomplete',
};

/** Le premier champ date / heure à moitié rempli du document (dialogs en portail compris). */
export function firstIncompleteDateInput(root: ParentNode = document): HTMLInputElement | null {
  const inputs = Array.from(root.querySelectorAll<HTMLInputElement>(DATE_INPUT_SELECTOR));
  return inputs.find(el => el.validity.badInput) ?? null;
}

/**
 * À appeler en tête de chaque enregistrement : refuse (toast + focus sur le
 * champ) s'il reste un champ date / heure à moitié rempli. Renvoie true si
 * l'enregistrement doit s'arrêter là.
 */
export function refuseIfDateInputIncomplete(t: (key: string) => string): boolean {
  const el = firstIncompleteDateInput();
  if (!el) return false;
  const kind = (el.type as DateInputKind) in INCOMPLETE_MESSAGE_KEY ? (el.type as DateInputKind) : 'datetime-local';
  toast.error(t(INCOMPLETE_MESSAGE_KEY[kind]));
  el.focus();
  return true;
}
